import "./../css/sass/styles.scss";

import { debouncer, documentReady, scrollToEl, toggleClass } from "./Utility/utils";
import "./components/animations";
import "./components/slider";
import "./components/video";
import "./components/modal";
import "./components/accordion";
import "./components/project-3-up";
import "./components/image-gallery";
import "./components/count-up";
import "./components/fixed-sidebar";
import "./components/post-filtering";
import "./components/hero";
import PV from "./Utility/petite-vue";

import imagesLoaded from "imagesloaded";

// Use this for all your js need
documentReady((event) => {
  const body = document.querySelector('body');

  // Set back button (on projects detail page template) to visible if not on the first page of a session.
  const postBackButton = () => {

    // track pages visited in an array to ensure back button goes to a page on this site
    // When back button is clicked, remove last item.
    let pagesVisited = sessionStorage.pagesVisited ? JSON.parse(sessionStorage.pagesVisited) : [];
    const currentPage = window.location.href;

    // First, check if the native back button might have been clicked
    // We'll check if the current page is the same as the second previous page of the array
    if(pagesVisited.length >= 2 && pagesVisited[pagesVisited.length - 2] == currentPage && sessionStorage.tdBackButtonClicked == 'false'){
      pagesVisited.pop();
      pagesVisited.pop();
      sessionStorage.pagesVisited = JSON.stringify(pagesVisited);
    }

    // Reset tdBackButtonClicked session storage variable
    sessionStorage.tdBackButtonClicked = 'false';

    // Determine if we should add the current page to the pagesVisited
    // If the previous page was the same as the current (page refresh), we won't
    const prevPage = pagesVisited.length ? pagesVisited[pagesVisited.length - 1] : false;
    if(!prevPage || prevPage !== currentPage){
      pagesVisited.push(currentPage);

      // Remove items from the beggining of the array if it gets to be longer than 5
      if(pagesVisited.length > 5){
        pagesVisited.shift();
      }

      sessionStorage.pagesVisited = JSON.stringify(pagesVisited);
    }

    const backButtons = document.querySelectorAll('.backButton');
    if(pagesVisited.length > 1){
      if(backButtons.length){
        backButtons.forEach(backButton => {
          backButton.classList.remove('hidden');

          backButton.addEventListener('click', () => {
            // Remove the last item from pagesVisited and reset sessionStorage.pagesVisited
            pagesVisited.pop();

            sessionStorage.pagesVisited = JSON.stringify(pagesVisited);
            sessionStorage.tdBackButtonClicked = 'true';
            history.back();
          });
        });
      }
    }
  }
  postBackButton();


  // Remove empty p tags accidentally placed by wordpress editor
  var elements = document.querySelectorAll("p");
  Array.prototype.forEach.call(elements, function (el, i) {
    let content = el.innerHTML;
    content = content.replace(/\s+/g, "");
    if (!content) {
      el.parentNode.removeChild(el);
    }
  });

  // Smooth Scrolling Anchor links / Prevent Default on href="#" links
  document.addEventListener(
    "click",
    function (e) {
      // loop parent nodes from the target to the delegation node
      for (var target = e.target; target && target != this; target = target.parentNode) {
        if (target.matches("a")) {
          const href = target.getAttribute("href");
          if (/^#/.test(href)) {
            const hash = href.substring(href.indexOf("#"));
            const hashTarget = document.getElementById(hash.substring(1));
            if (hash !== "#" && hashTarget && !hashTarget.classList.contains('modal')) {
              e.preventDefault();
              target.blur();
              scrollToEl(hashTarget);
            } else if (hash == "#") {
              e.preventDefault();
              target.blur();
            }
          }
          break;
        }
      }
    },
    false
  );

  // Set window width css variable
  const setBodyWidth = () => {
    windowWidth = body.offsetWidth;
    body.style.setProperty('--window-width', windowWidth + 'px');
  }
  setBodyWidth();
  let bodyWidthTimeout;
  window.addEventListener('resize', function(){
    clearTimeout(bodyWidthTimeout);
    bodyWidthTimeout = setTimeout(() => {
      setBodyWidth();
    }, 30);
    
  });

  // Share buttons
  const shareButtons = document.querySelectorAll('.btn__share');
  if(shareButtons){
    shareButtons.forEach(shareButton => {
      shareButton.addEventListener('click', (e) => {
        e.preventDefault();
        shareButton.blur();
        const target = shareButton.nextElementSibling;
        if(!!target){
          toggleClass(target, 'active');

          if(target.classList.contains('active')){
            target.setAttribute('aria-expanded', 'true');
          } else {
            target.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  }
});

document.addEventListener('pageloaded', () => {
  const body = document.querySelector('body');

  // Show/Hide Nav/fixed headers
  let lastScrollPos = 0

  // Set up post header data
  const postHero = document.querySelector('.post_header');
  let postHeroHeight = 0;
  let postFixedNavHeight = 0;

  if(!!postHero){

    const setPostHeroHeight = () => {
      if(!!postHero){
        postHeroHeight = postHero.offsetHeight + postHero.getBoundingClientRect().top + window.pageYOffset + 100;
        postFixedNavHeight = postHero.querySelector('.post_header__fixed').offsetHeight;

        body.style.setProperty('--post-header-height-computed', postFixedNavHeight + 'px');
      }
    }
    setPostHeroHeight();

    let postHeroHeightChecker;
    window.addEventListener('resize', () => {
      clearTimeout(postHeroHeightChecker);
      postHeroHeightChecker = setTimeout(() => {
        setPostHeroHeight();
      }, 100);
    });
  }

  const scrollClasses = () => {
    const scrollPos = window.scrollY;

    // Fixed Nav Class
    if(scrollPos < 700 || scrollPos < lastScrollPos){
      body.classList.add('showFixedNav');
    }
    else if(body.classList.contains('showFixedNav')) {
      body.classList.remove('showFixedNav');
    }

    // Project Header Class
    if(!!postHero){
      let triggerPoint = 800;
      if(scrollPos > postHeroHeight){
        body.classList.add('showPostFixedHeader');
      }
      else if(body.classList.contains('showPostFixedHeader')) {
        body.classList.remove('showPostFixedHeader');
      }
    }

    lastScrollPos = scrollPos;
  }
  scrollClasses();

  window.addEventListener('scroll', () => {
    scrollClasses();
  });

});

window.addEventListener("load", function (event) {
  // Preload images
  const preloadImages = () => {
    return new Promise((resolve, reject) => {
      var imgLoad = imagesLoaded(
        document.querySelectorAll("img"),
        {
          background: true,
        },
        resolve
      );
    });
  };
  preloadImages().then(() => {
    const bodyEl = document.getElementsByTagName("body")[0];
    var event = new CustomEvent("pageloaded");
    bodyEl.classList.remove("loading");
    document.dispatchEvent(event);
  });


  PV.mount('body');

});
